import Vue from "vue";
import App from "@/App.vue";
import Vuex from "vuex";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/Login.vue";
import Reset from "@/views/Reset.vue";
import Field from "@/components/Field.vue";
import Password from "@/views/Password.vue";
import Consent from "@/components/Consent.vue";
import ConsentGroup from "@/components/ConsentGroup.vue";
import SendAnimaCompare from "@/views/SendAnimaCompare.vue";
import DocOCR from "@tecnike/dococr";

function addRouter() {
  Vue.use(VueRouter);
  const routes: RouteConfig[] = [
    {
      path: "/",
      name: "Home",
      component: () => import(/* webpackChunkName: "home" */"@/views/Home.vue")
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path:"/send-anima-compare",
      name:"SendAnimaCompare",
      component: SendAnimaCompare
    },
    {
      path: "/reset",
      name: "Reset",
      component: Reset
    },
    {
      path: "/reset/password/:token",
      name: "Password",
      component: Password
    },
    {
      path: "/new-customer-scan",
      name: "NewCustomerScan",
      component: () => import(/* webpackChunkName: "new-customer-scan" */"@/views/NewCustomerScan.vue")
    },
    {
      path: "/new-customer-data",
      name: "NewCustomerData",
      component: () => import(/* webpackChunkName: "new-customer-data" */"@/views/NewCustomerData.vue")
    },
    {
      path: "/customer/:id",
      name: "Customer",
      component: () => import(/* webpackChunkName: "customer" */"@/views/Customer.vue"),
      props: true
    },
    {
      path: "/customers-consents",
      name: "CustomersConsents",
      component: () => import(/* webpackChunkName: "customersConsents" */"@/views/CustomersConsents.vue")
    },
    {
      path: "/customers",
      name: "Customers",
      component: () => import(/* webpackChunkName: "customers" */"@/views/Customers.vue"),
      props: true
    },
    {
      path: "/playground",
      name: "Playground",
      component: () => import(/* webpackChunkName: "playground" */"@/views/Playground.vue")
    }
  ];

  return new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
  });
}
function addStore() {
  Vue.use(Vuex);

  interface StoreState {
    scanResult?: DocOCR.DocOCRResult;
  }

  return new Vuex.Store({
    state: {
      scanResult: undefined
    } as StoreState,

    mutations: {
      "scanResult-set": function (state, scanResult) {
        state.scanResult = scanResult;
      },

      "scanResult-clear": function (state) {
        state.scanResult = undefined;
      }
    }
  });
}

const router = addRouter();
const store = addStore();

Vue.config.ignoredElements = [
  "doc-ocr"
];

Vue.config.productionTip = false;

// Notifica di errore.
Vue.prototype.$error = function (message: string) {
  this.$q.notify({
    progress: true,
    message: message,
    type: "negative"
  });
};

// Storage persistente.
Vue.prototype.$persistency = window.localStorage;

// Autenticazione
Vue.mixin({
  beforeMount() {
    if (router.currentRoute.path === "/login" || router.currentRoute.path === "/reset" || router.currentRoute.params.token != null) {
      return;
    }

    const accessToken = Vue.prototype.$persistency.getItem("accessToken");
    if (!accessToken) {
      router.push("/login");
      //router.push({path :"/reset/password" , query: {type : null}});
    }
  }
});

// Componenti custom utili.
Vue.component("c-field", Field);
Vue.component("c-consent", Consent);
Vue.component("c-consent-group", ConsentGroup);

const instance = new Vue({
  router: router,
  store: store,
  render: h => h(App)
});

instance.$mount("#app");

// Gestore globale di errori non gestiti.
if (window) {
  window.onerror = function (msg, url, line, col, error) {
    instance.$q.loading.hide();

    instance.$q.notify({
      progress: true,
      message: msg.toString(),
      type: "negative"
    });

    return true;
  };
}
